import exologAdmin from '@/exologAdmin'
import $$ from 'jquery'
import overlay from '@/common/overlay'
import './exolog-forms'


if (process.env.NODE_ENV !== 'production') {
    console.info('-==development mode==-');
} else {
    //console.info('-==production mode==-');
}
let exologLoader = {
    async init() {
        exologAdmin.init()

        if ($$('meta[name="exologEditor"]').length) {
            await this.initExologEditor()
        }
    },
    async initExologEditor() {
        overlay.show('body')
        let exologEditor = (await import(/* webpackChunkName: "exolog-editor" */'@/exologEditor')).default
        exologEditor.init()
    },
}

$$(_ => {
    exologLoader.init()
})
